module.exports = __webpack_public_path__ + "static/media/3dmodeling_01.9ed4c9ce.png";